export var IRequestErrorCode = /*#__PURE__*/ function (IRequestErrorCode) {
    /** Custom code used by our BE to indicate that client and server entity state do mismatch while `/retry` endpoint was called */
    IRequestErrorCode[IRequestErrorCode["EntityStatusRetryCurrentStateMismatch"] = 11061] = "EntityStatusRetryCurrentStateMismatch";
    IRequestErrorCode[IRequestErrorCode["SessionExpired"] = 1009] = "SessionExpired";
    /**
     * Custom code used by our BE to indicate that feature tier downgrade is happening in an order
     */
    IRequestErrorCode[IRequestErrorCode["OrderFeatureReductionError"] = 13016] = "OrderFeatureReductionError";
    return IRequestErrorCode;
}({});
